module.exports = __webpack_public_path__ + "img/8.5be07d64.jpg";